var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluebird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 46,
    viewBox: "0 0 97 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9969 8.11628C28.9969 8.11628 36.6644 15.958 46.1581 18.3105C46.1581 18.3105 52.7144 20.0735 60.3038 18.7499C60.3038 18.7499 63.9896 17.3539 66.1954 18.8945C66.1954 18.8945 67.6698 19.8455 67.8876 20.1403C67.8876 20.1403 67.5916 20.5073 66.7818 20.8744C65.9721 21.2414 62.2863 27.1033 61.6999 27.5092C61.1079 27.9152 58.2375 31.4357 55.5848 31.3634C52.9322 31.2911 41.8245 26.1022 36.5248 20.1625C36.5248 20.1625 30.6834 13.3663 29.2705 9.26195C29.2705 9.26195 28.5948 7.71585 28.9969 8.11628Z",
    fill: "#009FE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.067 30.5847C35.067 30.5847 40.6571 29.5281 44.6724 29.8673C44.6724 29.8673 48.7547 29.9007 52.9766 32.2254C52.9766 32.2254 53.5574 32.6369 52.3232 32.7371C51.089 32.8372 46.7331 35.0284 44.9795 36.4966C44.9795 36.4966 44.2256 37.3865 43.8459 36.1184C43.4661 34.856 43.2986 33.1097 36.949 31.2299C36.949 31.2299 35.9047 30.924 35.1452 30.924C35.1508 30.924 34.5644 30.7238 35.067 30.5847Z",
    fill: "#009FE3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluebird);
export default __webpack_public_path__ + "static/media/Bluebird.06d72eb5a8e0a11ed195ac6045188180.svg";
export { ForwardRef as ReactComponent };